<template>
  <div id="kariCheckbox">
    <div class="checkboxMask">
      <checkbox-icon v-if="check"/>
    </div>
    <input v-model="check" type="checkbox">
  </div>
</template>

<script>
import CheckboxIcon from '@/assets/svg/checkboxIcon';
export default {
  name: 'checkbox-input',
  components: { CheckboxIcon },
  data () {
    return {
      check: true
    };
  }
};
</script>

<style scoped>
/*чекбокс*/
#kariCheckbox {position: relative; margin-right: 2.13vw }
#kariCheckbox>.checkboxMask { width: 5.33vw; height: 5.33vw; background: rgba(153, 30, 102, 1); border-radius: 4px; position: absolute; pointer-events: none; display: flex; align-items: center; justify-content: center }
#kariCheckbox>input { width: 5.33vw; height: 5.33vw; cursor: pointer; opacity: 0 }

@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #kariCheckbox { margin-right: 16px }
  #kariCheckbox>.checkboxMask { width: 20px; height: 20px }
  #kariCheckbox>input { width:20px; height: 20px; opacity: 0 }
}

</style>
